import React from "react";
import { TrendingUp, TrendingDown, ArrowDownCircle, ArrowUpCircle, Wallet } from "lucide-react";
import { money } from "./utils";

function StatCard({ label, value, tone, icon: Icon }) {
  const toneCls =
    tone === "emerald" ? "text-emerald-700" :
    tone === "rose" ? "text-rose-700" :
    tone === "brand" ? "text-[#00b4ff]" :
    tone === "slate" ? "text-slate-700" : "text-slate-900";
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5">
      <div className="flex items-center justify-between">
        <div className="text-[11px] font-mono-plex font-semibold tracking-widest uppercase text-slate-700">{label}</div>
        {Icon && <Icon size={14} className="text-slate-300" />}
      </div>
      <div className={`mt-2 font-display font-bold text-2xl md:text-3xl tracking-tight ${toneCls}`}>{value}</div>
    </div>
  );
}

export default function JournalStats({ totals }) {
  const totalBalance = totals.deposit + totals.netPnl - totals.withdraw;
  return (
    <>
      {/* Balance highlight */}
      <div className="rounded-2xl border border-slate-900 bg-slate-900 text-white p-5 md:p-6 mb-4" data-testid="journal-total-balance">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-[10px] font-mono-plex tracking-[0.28em] uppercase text-slate-400">Total Balance</div>
            <div className="text-[10px] font-mono-plex tracking-widest text-slate-500 mt-0.5">Deposit + Net P&L − Withdraw</div>
          </div>
          <Wallet size={20} className="text-[#00b4ff]" />
        </div>
        <div className={`mt-3 font-display font-bold text-3xl md:text-4xl tracking-tight ${totalBalance >= 0 ? "text-white" : "text-rose-400"}`}>
          ${totalBalance.toFixed(2)}
        </div>
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[11px] font-mono-plex tracking-widest text-slate-400">
          <span>Deposit <span className="text-[#00b4ff] font-semibold">${totals.deposit.toFixed(2)}</span></span>
          <span>+ Net <span className={`font-semibold ${totals.netPnl >= 0 ? "text-emerald-400" : "text-rose-400"}`}>{money(totals.netPnl)}</span></span>
          <span>− Withdraw <span className="text-slate-300 font-semibold">${totals.withdraw.toFixed(2)}</span></span>
        </div>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
        <StatCard label="Profit" value={`$${totals.profit.toFixed(2)}`} tone="emerald" icon={TrendingUp} />
        <StatCard label="Loss" value={`$${totals.loss.toFixed(2)}`} tone="rose" icon={TrendingDown} />
        <StatCard label="Net P&L" value={money(totals.netPnl)} tone={totals.netPnl >= 0 ? "emerald" : "rose"} />
        <StatCard label="Deposit" value={`$${totals.deposit.toFixed(2)}`} tone="brand" icon={ArrowDownCircle} />
        <StatCard label="Withdraw" value={`$${totals.withdraw.toFixed(2)}`} tone="slate" icon={ArrowUpCircle} />
      </div>
    </>
  );
}
